module.exports = __webpack_public_path__ + "static/media/MasterCard.45abacc9.svg";